module.exports = __webpack_public_path__ + "img/Number=49.672d6d30.png";